module.exports = __webpack_public_path__ + "imgs/delete.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/delete.png
// module id = 226
// module chunks = 93